module.exports = __webpack_public_path__ + "1a780df99d605ffa930afba7dd292d88.jpg";